import { render } from "./DeleteTagsModal.vue?vue&type=template&id=005e101e&scoped=true"
import script from "./DeleteTagsModal.vue?vue&type=script&lang=js"
export * from "./DeleteTagsModal.vue?vue&type=script&lang=js"

import "./DeleteTagsModal.vue?vue&type=style&index=0&id=005e101e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-005e101e"]])

export default __exports__